import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const twoFactorAPI = {
    getStatus: async () => {
        try {
            const { data } = await api.get('/api/2fa/status/');
            return data;
        } catch (error) {
            handleApiError(error, 'Get 2FA status error:');
        }
    },
    
    setup: async () => {
        try {
            const { data } = await api.post('/api/2fa/setup/');
            return data;
        } catch (error) {
            handleApiError(error, 'Setup 2FA error:');
        }
    },
    
    verifySetup: async (token) => {
        try {
            const { data } = await api.post('/api/2fa/verify-setup/', { token });
            return data;
        } catch (error) {
            handleApiError(error, 'Verify 2FA setup error:');
        }
    },
    
    verifyLogin: async (username, token) => {
        try {
            const { data } = await api.post('/api/2fa/verify-login/', { username, token });
            return data;
        } catch (error) {
            handleApiError(error, 'Verify 2FA login error:');
        }
    },
    
    disable: async () => {
        try {
            const { data } = await api.post('/api/2fa/disable/');
            return data;
        } catch (error) {
            handleApiError(error, 'Disable 2FA error:');
        }
    },

    adminDisable: async (userId) => {
        try {
            const { data } = await api.post(`/api/permissions/user/${userId}/disable-2fa/`);
            return data;
        } catch (error) {
            handleApiError(error, 'Admin disable 2FA error:');
        }
    },
};
